<script setup lang="ts">
  import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
  } from '@ui/components/alert-dialog';
  import { Button } from '@ui/components/button';

  interface Props {
    description: string;
    isOpen: boolean;
    title: string;
  }

  const props = defineProps<Props>();

  const emit = defineEmits(['update:isOpen', 'confirmed']);

  const handleCancel = () => {
    emit('update:isOpen', false);
  };

  const handleConfirm = () => {
    emit('update:isOpen', false);
    emit('confirmed');
  };
</script>

<template>
  <AlertDialog :open="isOpen" @update:open="emit('update:isOpen', $event)">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>
          {{ title }}
        </AlertDialogTitle>
        <AlertDialogDescription>
          {{ description }}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button variant="secondary" @click="handleCancel"> Cancel </Button>
        <Button variant="destructive" @click="handleConfirm"> Confirm </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>

<style scoped></style>
